<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M3 12a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 1 0-2 0v2a1 1 0 1 0 2 0 .5.5 0 0 1 1 0 2 2 0 1 1-4 0v-2c0-1.1.9-2 2-2Zm4.5 0c.83 0 1.5.67 1.5 1.5a.5.5 0 0 1-.99.1l-.02-.2a.5.5 0 0 0-.99.1v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 .99-.1l.02.2a.5.5 0 0 0 .99-.1v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 6 13.88v-.38c0-.83.67-1.5 1.5-1.5Zm5.53.34a.5.5 0 1 1 .94.32l-1.75 5a.5.5 0 0 1-.94 0l-1.75-5a.5.5 0 0 1 .94-.32l1.28 3.65 1.28-3.65ZM10 6.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-1.34l1.76-5a1.5 1.5 0 0 0-.78-1.86l-.14-.06-.15-.04a1.5 1.5 0 0 0-1.7.82l-.07.14-.33.96-.33-.96-.06-.14a1.5 1.5 0 0 0-1.7-.82l-.16.04a.94.94 0 0 0-.51.41 2.49 2.49 0 0 0-3.61.68 3 3 0 0 0-1.38-1V3.5C4 2.67 4.67 2 5.5 2H10v4.5Zm5.75.5H11.5a.5.5 0 0 1-.5-.5V2.25L15.75 7Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M3 12a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 1 0-2 0v2a1 1 0 1 0 2 0 .5.5 0 0 1 1 0 2 2 0 1 1-4 0v-2c0-1.1.9-2 2-2Zm4.5 0c.83 0 1.5.67 1.5 1.5a.5.5 0 0 1-.99.1l-.02-.2a.5.5 0 0 0-.99.1v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 .99-.1l.02.2a.5.5 0 0 0 .99-.1v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 6 13.88v-.38c0-.83.67-1.5 1.5-1.5Zm5.53.34a.5.5 0 1 1 .94.32l-1.75 5a.5.5 0 0 1-.94 0l-1.75-5a.5.5 0 0 1 .94-.32l1.28 3.65 1.28-3.65ZM10.59 2c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-1.77 1.99h-.05L14 18h-.84l.35-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v7.76a3 3 0 0 0-1-.59V4c0-1.1.9-2 2-2h4.59ZM11 6.5c0 .28.22.5.5.5h3.3L11 3.2v3.3Z"
    />
  </svg>
</template>
